export default __webpack_public_path__ + "static/media/r7.67e69a09.jpg";